export function SpotsEmptyState({
  hasActiveFilter = false,
}: {
  /** カテゴリ絞り込み中なら true。 別カテゴリへの誘導文を出すかの判定に使う。 */
  hasActiveFilter?: boolean;
}) {
  return (
    <div className="border-dx-border-default mx-[16px] flex flex-col items-center justify-center gap-[8px] rounded-sm border border-dashed py-[64px] text-center">
      <p className="dx-body-2 text-dx-text-sub">該当するスポットがありません</p>
      {hasActiveFilter && (
        <p className="dx-body-3 text-dx-text-muted">
          別のカテゴリを選択してください
        </p>
      )}
    </div>
  );
}
